<ng-container *ngIf="ventilationMode$ | async | ready as feature">
  <div class="section-wrapper">
    <h3>
      {{ '+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_MODE.TITLE' | translate }}
    </h3>
    <mat-radio-group
      *ngIf="feature.properties?.value?.value"
      [ngModel]="feature.properties.value.value"
      class="flex flex-row flex-wrap lt-md:flex-col"
      [disabled]="!(feature | executable: 'setMode')"
      (change)="onOptionChange($event); trackVentilationOperatingMode()"
    >
      <ng-container *ngIf="feature | executable: 'setMode'">
        <ng-container *ngIf="isContinuousSensorOverrideMode; else deviceModes">
          <ng-container>
            <vi-radio-button
              [attr.data-at-ventilation-operating-mode]="mode"
              [attr.data-at-checked]="mode === feature.properties.value.value"
              *ngFor="let mode of feature.commands.setMode?.params?.mode?.constraints?.enum"
              [value]="mode"
              [label]="mode | translateVentilationMode"
              [checked]="mode === feature.properties.value.value"
              [disabled]="isBlockedByContinuousSensorOverride()"
              [viConfirm]="viConfirmObject"
              (confirm)="confirmWarning(mode)"
              (cancel)="trackVentilationOperatingMode()"
            >
            </vi-radio-button>
          </ng-container>

          <vi-radio-button
            [label]="
              '+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_MODE.CONTINUOUS_SENSOROVERRIDE'
                | translate
            "
            [checked]="true"
          >
          </vi-radio-button>
        </ng-container>

        <ng-template #deviceModes>
          <vi-radio-button
            [attr.data-at-ventilation-operating-mode]="mode"
            [attr.data-at-checked]="mode === feature.properties.value.value"
            *ngFor="let mode of feature.commands.setMode?.params?.mode?.constraints?.enum"
            [value]="mode"
            [label]="mode | translateVentilationMode"
            [checked]="mode === feature.properties.value.value"
          >
          </vi-radio-button>
        </ng-template>
      </ng-container>

      <vi-radio-button
        [attr.data-at-operating-mode]="feature.properties.value.value"
        data-at-checked="true"
        *ngIf="!(feature | executable: 'setMode')"
        [value]="feature.properties.value.value"
        [label]="feature.properties.value.value | translateVentilationMode"
        [checked]="true"
      >
      </vi-radio-button>
    </mat-radio-group>
  </div>

  <div *ngIf="feature.properties.value.value === 'permanent'" class="section-wrapper flex flex-col">
    <div class="flex flex-row">
      <h3>{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.OPERATING_PROGRAM.TITLE' | translate }}</h3>
    </div>

    <div
      class="flex flex-row flex-[20%] max-w-[20%] lt-md:flex-[30%] lt-md:max-w-[30%] lt-sm:flex-[100%] lt-sm:max-w-[100%]"
    >
      <ng-container feature *ngIf="ventilationProgram$ | async | ready as featureProgram">
        <vi-dropdown
          *ngIf="ventilationPermanent$ | async | ready as featurePermanent"
          feature
          data-at-ventilation-permanent-level
          [options]="ventilationPermanentOptions"
          [option]="
            featurePermanent.properties?.value?.value || featureProgram.properties?.value?.value
          "
          (optionChange)="onPermanentLevelChange($event)"
        >
        </vi-dropdown>
      </ng-container>
    </div>
  </div>
</ng-container>
